import React from "react";

const Autocomplete = () => {
  return <div>Testing Autocomplete</div>;
};

export default Autocomplete;
